<template>
    <div class="container">
        <div class="parking-items-section" :class="'parking-items-section-' + parkingListView">
            <div class="parking-item" v-for="item in parkingItems" :class="'parking-view-' + parkingListView">
                <div class="grid-head" v-if="parkingListView == 'grid'">
                    <h3>{{ filterCMSparams.words_translation.parking_card_title }} {{ item.size }} <span>м²</span></h3>
                </div>
                <div class="item-head-mobile" v-if="parkingListView == 'list' && isMobileChecker">
                    <div class="info-value info-value-price">{{ getNumber(item.price_full) }} тг</div>
                    <div class="info-value">{{ item.project.name }}</div>
                    <div class="info-value info-value-part">{{ parseInt(item.part.label) }} {{ filterCMSparams.words_translation.part }}</div>
                    <div class="info-value info-value-rent" v-if="item.rent == 'true'">{{getNumber(item.rent_price) }} тг - {{ filterCMSparams.words_translation.rent }}</div>
                </div>
                <div class="item-info">
                    <ul>
                        <li class="grid-list">
                            <div class="info-label">{{ filterCMSparams.words_translation.project }}</div>
                            <div class="info-value info-value-project">{{ item.project.name }}</div>
                        </li>
                        <li class="grid-list">
                            <div class="info-label">{{ filterCMSparams.words_translation.part }}</div>
                            <div class="info-value">{{ parseInt(item.part.label) }}</div>
                        </li>
                        <li>
                            <div class="info-label">{{ filterCMSparams.words_translation.class }}</div>
                            <div class="info-value">{{ getCorrectSTRword(item.type.label) }}</div>
                        </li>
                        <li>
                            <div class="info-label">{{ filterCMSparams.words_translation.level }}</div>
                            <div class="info-value">{{ item.level }} <span v-if="isMobileChecker">ур.</span></div>
                        </li>
                        <li>
                            <div class="info-label">{{ filterCMSparams.words_translation.size }}</div>
                            <div class="info-value size-value">{{ item.size }} <span v-if="isMobileChecker">м²</span></div>
                        </li>
                        <li v-if="item.rent == 'true' && parkingListView == 'grid'">
                            <div class="info-label">{{ filterCMSparams.words_translation.rent }}</div>
                            <div class="info-value size-value">{{ getNumber(item.rent_price) }} <span>тг</span></div>
                        </li>
                        <li v-if="parkingListView != 'grid' && !isMobileChecker">
                            <div class="info-label">{{ filterCMSparams.words_translation.price }}</div>
                            <div class="info-value price-value">{{ getNumber(item.price_full) }} тг</div>
                        </li>
                    </ul>
                </div>
                <div class="grid-bottom" v-if="parkingListView == 'grid'">
                    <div class="price">
                        <span>{{ getNumber(item.price_full) }} тг</span>
                    </div>
                    <div class="btn-more btn-wow-effect-hover" @click="openFormConsult(item)">
                        <span v-if="globalLang == ''">Оставить заявку</span>
                        <span v-if="globalLang == 'kz/'">Толығырақ</span>
                        <svgIcon name="arrow-right" class="icon-right-arrow"/>
                    </div>
                </div>
                <div class="favorite-item">
                    <a href="#" @click.prevent="sendToFavorite(item), toogleActiveClass($event)" :class="{'active' : checkIfFavorite(item)}">
                        <svgIcon name="favorite-disactive" class="icon-favorite"/>
                        <svgIcon name="favorite-active" class="icon-favorite-active"/>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import svgIcon from '@/components/partials/SvgIcon.vue'
    export default {
        name: 'parking-items-section',
        components: {
            svgIcon,
        },
        data () {
            return {
                globalLang: window.GlobalLang, 
            }
        },
        computed: mapGetters({
            // indexPage: 'loadIndexPage',
            filterCMSparams: 'loadFilterCMSparams',
            parkingItems: 'loadParkingItems',
            parkingItemsAnimate: 'loadParkingItemsAnimate',
            parkingListView: 'loadParkingListView',
            isMobileChecker: 'loadIsMobileChecker',
        }),
        methods: {
            getNumber(n) {
                return String(n).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1 ")
            },
            getCorrectSTRword(str) {
                if (this.globalLang != 'kz/') {
                    return str;
                } else {
                    if (str == 'Стандартное') {
                        return 'Стандарт';
                    } else if (str == 'VIP') {
                        return str;
                    } else if (str == 'Зависимое') {
                        return 'Тәуелді';
                    } else if (str == 'Откатное') {
                        return 'Жылжымалы';
                    } else if (str == 'Среднее') {
                        return 'Орташа';
                    } else if (str == 'Малое') {
                        return 'Шағын';
                    } else if (str == 'Большое') {
                        return 'Үлкен'
                    }
                }
            },
            sendToFavorite(arr) {
                // console.log(arr)
                var favorites = JSON.parse(localStorage.getItem('favorite_parking_dial')) || [];
                var finder = this.checkIfFavorite(arr); // проверка наличия объекта в массиве избранных
                if (!finder) { // Добавляем объект в массив если такого объекта не обнаружено в массиве
                    favorites.push(arr);
                    localStorage.setItem('favorite_parking_dial', JSON.stringify(favorites));
                    this.$store.commit('FavoriteLocalStorageUpdate', !this.favoriteLocalStorageUpdate);
                } else { // Убираем из массива если такой объект уже есть в избранном
                    favorites = favorites.filter(favorite => favorite.id != arr.id);
                    localStorage.setItem('favorite_parking_dial', JSON.stringify(favorites));
                    this.$store.commit('FavoriteLocalStorageUpdate', !this.favoriteLocalStorageUpdate);
                    // console.log(favorites, 'asdasdasdasdasd')
                }
            },
            checkIfFavorite(arr) { // проверка наличия объекта в массиве избранных
                var favorites = JSON.parse(localStorage.getItem('favorite_parking_dial')) || [];
                var finder = favorites.some(favorite => favorite.id === arr.id); 
                return finder;
            },
            toogleActiveClass(event) {
                event.currentTarget.classList.toggle('active');
            },
            openFormConsult(arr) {
                console.log(arr)
                var dataArr = {
                    project: arr.project.name,
                    id: arr.id,
                    part: arr.part.label,
                    type: arr.type.label,
                    level: arr.level,
                    size: arr.size + ' м²',
                    price: this.getNumber(arr.price_full) + ' тг.',
                };
                // console.log(dataArr, 'form data arr')
                this.$store.commit('formsModalRealEstate_setData', dataArr);
                this.$store.commit('formGlobalDataModal_set', {'page' : 'parking', 'block' : 'Карточка паркинга'});
                this.$store.commit('formGlobalParam_set', 'parking-form');
                this.$store.commit('formModalContainerOpen');
            },  
        },
        beforeCreate() {
        },
        created () {
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/parking-page/parking-items.scss';
    @import '@/styles/components/parking-page/respond/parking-items-respond.scss';
</style>